import React, { useState } from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import {
  presentFormatedData,
  presentDate,
} from '../../functionalComponents/dataFormatFunctions';
import SingleRow from './SingleRow';
import { useHistory } from 'react-router-dom';
import CustomTableCell from '../../models/table/CustomTableCell';
import moment from 'moment';
import { header } from './header';
import { useSelector } from 'react-redux';

function ExpandableRow(props) {
  const [open, setOpen] = useState(false);
  const history = useHistory();
  const SADetails = props.row;
  const [SLDetails, setSLDetails] = useState(
    SADetails.SLDetails
  );
  const { openPOLineDetails, customizeTable } = props;

  const featuresAccess = useSelector(
        (state) =>
          state.pcmp.common.accessControl.featuresAccess.poManagementFeatures
      );

  React.useEffect(() => {
    setSLDetails(SADetails.SLDetails);
  }, [SADetails.SLDetails, props]);

  const handleViewClick = (poNumber, vendorName) => {
    //console.log(poNumber)
    //console.log(vendorName)
    history.push(`/pcmp/${localStorage.collabType}/${localStorage.roleName}/${localStorage.organizationName}/${localStorage.ecosystemId}/schedule agreements`, {
      state: {
        searchText: poNumber, // Replace with actual PO number
        viewByValue: 'all',
        filterByValue: vendorName, // Vendor name
      },
    });
  };

  return (
    <React.Fragment>
      {/** Show the SA Header when there is no search query
       * and maintain the view when search is under process
       */}
        <SingleRow
          SADetails={SADetails}
          openPOLineDetails={openPOLineDetails}
          setOpen={setOpen}
          open={open}
        keys={props.keys}
        customizeTable={customizeTable}
        featuresAccess={featuresAccess}
        />
      {/** Open DS view when expand is clicked and when (search is enabled and loading is done) */}
      {(open === true ) &&
        SLDetails.map((row, i) => {
          return (
            <TableRow
              key={row.scheduleLineItemNumber}
              style={{
                backgroundColor: props.keys % 2 === 0 ? '#FFF' : '#0000000a',
              }}
            >
              <TableCell
                style={{
                  width: '1%',
                  maxWidth: 0,
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                }}
              ></TableCell>

              {header(localStorage.collabType !== "CMO", true, customizeTable, featuresAccess?.clickHereToViewBatches).filter((val) => val.id === 'poline').length > 0
                        ? 
                        <CustomTableCell
                          scope='row'
                          align='left'
                          elementStyle={{ maxWidth: '7rem' }}
                        >
                          {SADetails.scheduleAgreementNumber ? `${SADetails.scheduleAgreementNumber} - ${row.scheduleLineItemNumber}`:presentFormatedData(SADetails.scheduleAgreementNumber)}
                        </CustomTableCell>
                        :
                        null
              }
              
              {header(localStorage.collabType !== "CMO", true, customizeTable, featuresAccess?.clickHereToViewBatches).filter((val) => val.id === 'cdmoPlant').length > 0
                        ? 
                        <CustomTableCell
                scope='row'
                align={'left'}
                elementStyle={{ maxWidth: '0px', whiteSpace:'break-spaces' }}
              >
                {SADetails.vendorName ? `${SADetails.vendorName} - ${row.vendorPlant}`: ""}
              </CustomTableCell>
                        :
                        null
              }
              
              {header(localStorage.collabType !== "CMO", true, customizeTable, featuresAccess?.clickHereToViewBatches).filter((val) => val.id === 'sponsor').length > 0
                        ? 
                        <CustomTableCell
                scope='row'
                align={'left'}
                elementStyle={{ maxWidth: '0px', whiteSpace:'break-spaces' }}
              >
                {SADetails.sponsorName ? `${SADetails.sponsorName}`: "NA"}
              </CustomTableCell>
                        :
                        null
                      }

              
{header(localStorage.collabType !== "CMO", true, customizeTable, featuresAccess?.clickHereToViewBatches).filter((val) => val.id === 'productCodeDescription').length > 0
                        ? 
                        <CustomTableCell
                scope='row'
                align='left'
                elementStyle={{ maxWidth: '0px' }}
              >
                {presentFormatedData(row.fgMaterialCode)} /<br />{' '}
                {presentFormatedData(row.fgMaterialName)}
              </CustomTableCell>
                        :
                        null
                      }

              
{header(localStorage.collabType !== "CMO", true, customizeTable, featuresAccess?.clickHereToViewBatches).filter((val) => val.id === 'dateOfDelivery').length > 0
                        ? 
                        <CustomTableCell
                scope='row'
                align={
                  row.deliveryDate === null || row.deliveryDate === ''
                    ? 'center'
                    : 'left'
                }
              >
                {row?.deliveryDate ? (
                                moment(row.deliveryDate).format(
                                  "DD-MMM-YYYY"
                                ).toUpperCase()
                              ) : (
                                "NA"
                              )}
              </CustomTableCell>
                        :
                        null
                      }
              

              {header(localStorage.collabType !== "CMO", true, customizeTable,featuresAccess?.clickHereToViewBatches).filter((val) => val.id === 'deliveredQty').length > 0
                        ? 
                        <CustomTableCell
                scope='row'
                align='right'
                elementStyle={{ maxWidth: '0px' }}
              >
                  {row.deliveryQuantityPercentage === null ||
                    row.deliveryQuantityPercentage === ''
                    ? '-'
                    : row.deliveryQuantityPercentage % 1 !== 0 ? Number(row.deliveryQuantityPercentage).toFixed(2) : row.deliveryQuantityPercentage}
              </CustomTableCell>
                        :
                        null
                      }
              
              

              {featuresAccess &&
                header(localStorage.collabType !== "CMO", true, customizeTable, featuresAccess?.clickHereToViewBatches).filter((val) => val.id === 'viewBatches').length > 0
                        ? 
                        <CustomTableCell
                scope='row'
                align='center'
                elementStyle={SADetails.poApprovedFlag 
                  ? { textAlign: 'center', color: '#0000EE', textDecoration: 'underline', cursor: 'pointer' } 
                  : { textAlign: 'center', color: '#000000' }
                }
                onClick={() => {
                  if (SADetails.poApprovedFlag) {
                    handleViewClick(SADetails.scheduleAgreementNumber, row.vendorName);
                  }
                }}
              >
                <span onClick={() => {
                  if (SADetails.poApprovedFlag) {
                    handleViewClick(SADetails.scheduleAgreementNumber, row.vendorName);
                  }
                }}
                >
                  {SADetails.poApprovedFlag === true ? "Click here to view" : "NA"}
                </span>
                
              </CustomTableCell>
                        :
                        null
                      }
              
    

              {header(localStorage.collabType !== "CMO", true, customizeTable, featuresAccess?.clickHereToViewBatches).filter((val) => val.id === 'poStatus').length > 0
                        ? 
                        <CustomTableCell
                          scope='row'
                          align='left'
                          elementStyle={{ maxWidth: '7rem' }}
                        >
                        </CustomTableCell>
                        :
                        null
                      }

{header(localStorage.collabType !== "CMO", true, customizeTable, featuresAccess?.clickHereToViewBatches).filter((val) => val.id === 'actions').length > 0
                        ? 
                        <CustomTableCell  align='left'>
                        </CustomTableCell>
                        :
                        null
                      }
            </TableRow>
          );
        })}
    </React.Fragment>
  );
}

export default ExpandableRow;
